<template>
  <v-container
    style="background-color: #21343b; position: relative"
    :class="$vuetify.breakpoint.width < 1264 ? 'px-7' : 'pl-12 pr-4'"
  >
    <v-row>
      <v-col style="color: white" v-if="!$vuetify.breakpoint.width < 1264">
        <b>{{ $t('profilePhoto') }}</b>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="$vuetify.breakpoint.width < 1264 ? 3 : 2">
        <v-avatar
          :color="userInfo.userDisplayName || userInfo.userFullName | iconBackground"
          class="logo"
          round
          size="50"
          style="cursor: pointer"
        >
          <div class="avatar-bg" v-if="userPicture"></div>
          <span class="white--text text-h6 cent" v-if="!userPicture">
            {{ userInfo.userDisplayName || userInfo.userFullName | iconFilter }}
          </span>

          <v-img :src="userPicture" v-if="userPicture" />
        </v-avatar>
      </v-col>
      <v-col align-self="center">
        <el-button
          class="btn-delete-logo"
          :disabled="!userPicture || userPicture === null"
          @click="deleteUserPicture"
          type="gray"
        >
          {{ $t('delete') }}
        </el-button>
        <el-button type="gray" class="logo">
          <label for="logo" style="color: white">{{ $t('upload') }}</label>
          <input accept=".png,.jpg,.jpeg" type="file" id="logo" @change="setUserPicture" />
        </el-button>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        :class="$vuetify.breakpoint.width < 1264 ? 'pt-0 pb-0 mt-2 text-left' : 'pt-0 pb-0 mt-5 text-left'"
        style="color: white"
      >
        <label for="fullName" class="text-left">
          <b>{{ $t('userFullName') }}</b>
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-1 pb-0">
        <v-text-field
          type="text"
          solo
          dense
          dark
          ref="fullName"
          id="fullName"
          :placeholder="$t('msgEnterUserFullName')"
          hide-details="auto"
          @keyup="somethingChange"
          v-model="userInfo.userFullName"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left" style="color: white">
        <label for="displayName" class="text-left">
          <b>{{ $t('userDisplayName') }}</b>
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-1 pb-0">
        <v-text-field
          type="text"
          dense
          solo
          dark
          ref="displayName"
          id="displayName"
          @keyup="somethingChange"
          :placeholder="$t('msgEnterUserDisplayName')"
          hide-details="auto"
          v-model="userInfo.userDisplayName"
        />
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left" style="color: white">
        <label for="password" class="text-left">
          <b>{{ $t('password') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button @click="changePassword" type="purple" style="width: 110px">{{ $t('update') }}</el-button>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left" style="color: white">
        <label class="text-left">
          <b>{{ $t('email') }}</b>
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label class="text-left" style="color: #96a7af">{{ userInfo.userEmail }}</label>
      </v-col>
      <v-col style="text-align: end">
        <el-button @click="changeEmail" type="purple" style="width: 110px">{{ $t('change') }}</el-button>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left" style="color: white">
        <label for="language" class="text-left">
          <b>{{ $t('languageMenu') }}</b>
        </label>
      </v-col>
      <v-col>
        <v-select
          id="language"
          no-gutters
          hide-details
          dark
          v-model="$i18n.locale"
          :items="langs"
          @change="updateLanguage"
          dense
          outlined
          style="width: 110px; background-color: #6952dc; border-color: #6952dc; font-size: 15px"
        >
          <template slot="selection" slot-scope="data">{{ $t(`language.${data.item}`) }}</template>
          <template slot="item" slot-scope="data">{{ $t(`language.${data.item}`) }}</template>
        </v-select>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left" style="color: white">
        <label class="text-left">
          <b>{{ $t('deleteAccount') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button @click="deleteAccount" type="danger" style="width: 110px">{{ $t('delete') }}</el-button>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left" style="color: white">
        <label class="text-left">
          <b>{{ $t('signOut') }}</b>
        </label>
      </v-col>
      <v-col style="text-align: end">
        <el-button @click="signOut" type="danger" style="width: 110px">{{ $t('signOut') }}</el-button>
      </v-col>
    </v-row>
    <v-row class="mt-10 mb-5 pr-3" justify="end">
      <v-btn class="btn-cancel mr-2" color="#777" dark @click="close">{{ $t('cancel') }}</v-btn>
      <v-btn
        color="rgb(40, 144, 103)"
        dark
        v-bind:class="isUpdate || isUserPictureChanged !== null ? 'active_primary' : 'gray'"
        :disabled="!isUpdate && !isUserPictureChanged"
        :loading="isLoading"
        @click="setUserUpdate"
      >
        Update
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import common from '@/common/common'
import { setUserUpdate, setFileUpload, setInvalidCache, deleteUserPicture } from '@/services/api'
import Toast from '@/views/meeting/component/Toast'
import firebase from 'firebase/app'
import { isMobile } from '@/common/lib/strLib'

export default {
  name: 'AccountSetting',
  created() {
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '계정 설정',
        firebase_screen_class: 'AccountSetting',
      },
    })
  },
  data() {
    return {
      userInfo: this.copyUserInfo(),
      userPicture: this.$store.getters.userInfo.userPicture,
      isUserPictureChanged: false,
      temp: this.$store.getters.userInfo,
      isLoading: false,
      isUpdate: false,
      errorCode: '',
      errorMessage: '',
      langs: ['en', 'ko'],
    }
  },
  methods: {
    ...mapGetters(['selectedCh']),
    ...mapActions(['setSignOut']),
    deleteUserPicture() {
      this.userPicture = null
      this.isUserPictureChanged = this.userInfo.userPicture && this.userInfo.userPicture !== null
    },
    setUserPicture(e) {
      // TODO: 모달창으로 설정하도록 변경 필요
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
      e.target.value = ''
    },
    createImage(file) {
      var reader = new FileReader()
      reader.onload = async (e) => {
        this.userPicture = await this.resizeImage(e.target.result)
        this.isUserPictureChanged = true
      }
      reader.readAsDataURL(file)
    },
    // TODO: common library로 이동
    resizeImage(base64Str, maxWidth = 160, maxHeight = 160) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    async uploadUserPicture() {
      // userPicture 업로드
      try {
        if (this.userPicture !== null) {
          // userPicture S3 업로드
          let parallellUploads = await setFileUpload(this, this.userPicture, 'userPicture', this.userInfo.userId)
          parallellUploads.on('httpUploadProgress', () => {
            // ctx.progressValue = Math.floor(100 / (progress.total / progress.loaded))
          })
          // S3 Upload
          await parallellUploads.done()
          // Cloud Front 캐시 삭제
          await setInvalidCache(this, `/userPicture/${this.userInfo.userId}.png`)
        }
        // userPicture 삭제
        else {
          try {
            await deleteUserPicture(this)
          } catch (err) {
            this.errorMessage = err
          }
        }
      } catch (err) {
        this.errorMessage = err
      }
    },
    signOut() {
      this.setSignOut()
      this.close()
      if (this.$route.name === 'Channel' && this.selectedCh && this.selectedCh['chCategory'] !== 'inbox') {
        this.$router.replace({ name: 'SignIn' }).catch(() => {})
      }
    },
    deleteAccount() {
      // notify(this, 'Error', this.$t('notAvailableFeatureMsg'), 'error')
      const content = {
        component: Toast,
        props: {
          msg: this.$t('notAvailableFeatureMsg'),
          // submsg: '',
        },
      }
      this.$toast.error(content)
    },
    changeEmail() {
      // notify(this, 'Error', this.$t('notAvailableFeatureMsg'), 'error')
      const content = {
        component: Toast,
        props: {
          msg: this.$t('notAvailableFeatureMsg'),
          // submsg: '',
        },
      }
      this.$toast.error(content)
    },
    async changePassword() {
      // notify(this, 'Success', this.$t('sendResetPassWord'), 'success')
      const content = {
        component: Toast,
        props: {
          msg: this.$t('sendResetPassWord'),
          // submsg: '',
        },
      }
      this.$toast.success(content)
      await firebase.auth().sendPasswordResetEmail(this.$store.getters.userInfo.userEmail)
    },
    copyUserInfo() {
      let userInfo = this.$store.getters.userInfo
      return {
        userId: userInfo.userId,
        userDisplayName: userInfo.userDisplayName,
        userFullName: userInfo.userFullName,
        userEmail: userInfo.userEmail,
        userPicture: userInfo.userPicture,
      }
    },
    somethingChange() {
      this.isUpdate = !(
        this.userInfo.userDisplayName === this.temp.userDisplayName &&
        this.userInfo.userFullName === this.temp.userFullName
      )
    },
    async setUserUpdate() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''

      if (this.isUserPictureChanged) await this.uploadUserPicture()

      if (this.isUpdate) {
        try {
          let result = await setUserUpdate(
            this,
            this.userInfo.userFullName.trim(),
            this.userInfo.userDisplayName.trim()
          )
          this.$store.commit('setUserInfo', result)
          // notify(this, 'Success', this.$t('updateSuccess'), 'success')
          this.close()
        } catch (error) {
          this.errorCode = error.response.status
          this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))
        }
      }

      if (
        (this.isUserPictureChanged || this.isUpdate) &&
        (this.errorMessage === undefined || this.errorMessage === null || this.errorMessage === '')
      ) {
        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('updateSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        this.isLoading = false
        location.reload()
      } else this.isLoading = false
    },
    // updateLanguage() {
    //   localStorage.setItem('Language', this.$i18n.locale)
    // },
    close() {
      this.$emit('close', 'Setting')
    },
  },
  computed: {
    isMobile() {
      return isMobile()
      // return true
    },
  },
}
</script>

<style scoped>
.el-button--gray {
  color: #fff;
  background-color: #31434f;
  border-color: #31434f;
}

.el-button--gray:hover {
  background: #31434f;
  border-color: #31434f;
  color: #fff;
}

.el-button--gray:active {
  background: #31434f;
  border-color: #31434f;
  color: #fff;
}

.el-button--gray:focus {
  background: #31434f;
  border-color: #31434f;
  color: #fff;
}

.el-button--purple {
  color: #fff;
  background-color: #6952dc;
  border-color: #6952dc;
}

.el-button--purple:hover {
  background: #6952dc;
  border-color: #6952dc;
  color: #fff;
}

.el-button--purple:active {
  background: #6952dc;
  border-color: #6952dc;
  color: #fff;
}

.el-button--purple:focus {
  background: #6952dc;
  border-color: #6952dc;
  color: #fff;
}

.active_primary {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.active_primary:hover {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.active_primary:active {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.active_primary:focus {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
}

.setting-detail >>> .dis_primary {
  background: #d4f5e9;
  border-color: #d4f5e9;
  color: #25c685;
}

.setting-detail >>> .dis_primary:hover {
  background: #d4f5e9;
  border-color: #d4f5e9;
  color: #25c685;
}

.v-list-item:not(.v-list-item--active) >>> .v-list-item__icon {
  color: #96a7af !important;
}

.btn-delete-logo {
  color: #fff;
  background-color: #31434f;
  border-color: #31434f;
}

.logo label {
  display: inline;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.logo label:hover {
  border-bottom: 1px solid #666;
}

.logo input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.logo img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}

.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
</style>
